import DarkLogo from "@/assets/images/montu-logo-dark-background.webp";
import LightLogo from "@/assets/images/montu-logo-light-background.webp";
import Login from "@/components/login";
import { useReactiveVar } from "@apollo/client/react";
import Google from "@repo/components/src/shared/login/Google";
import Microsoft from "@repo/components/src/shared/login/Microsoft";
import { LoginButtonProps } from "@repo/components/src/shared/login/types";
import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { Card } from "@repo/components/src/ui/card";
import { Divider } from "@repo/components/src/ui/divider";
import { Image } from "@repo/components/src/ui/image";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { isLoggedIn, logIn } from "@repo/graphql/client/states";
import { MyUserCenterDocument } from "@repo/graphql/documents/user/query.generated";
import { Link, Redirect, useTheme } from "expo-router";
import * as WebBrowser from "expo-web-browser";
import { ScrollView } from "react-native";

WebBrowser.maybeCompleteAuthSession();

const routerHandler: LoginButtonProps["routerHandler"] = (props) => {
  const { tokenAuth, client } = props;
  logIn(tokenAuth, client);
};

const Index = () => {
  const theme = useTheme();
  const loggedIn = useReactiveVar(isLoggedIn);
  if (loggedIn === true) {
    return <Redirect href={{ pathname: "/app" }} />;
  }
  return (
    <ScrollView className="p-margins pt-16">
      <Card
        variant="elevated"
        className="max-w-[500px] w-full mx-auto drop-shadow-2xl"
        size="xl"
      >
        <Image
          source={theme.dark ? DarkLogo : LightLogo}
          className="w-full max-w-56 mx-auto"
          mantainAspect
          contentFit="contain"
          alt="Login logo"
        />
        <Box className="mt-3">
          <Login />
        </Box>
        <Divider className="my-4" />
        <VStack className="items-center" space="md">
          <Google
            size="md"
            rounded="lg"
            className="w-full"
            routerHandler={routerHandler}
            refetchQueries={[MyUserCenterDocument]}
          />
          <Microsoft
            size="md"
            rounded="lg"
            className="w-full"
            routerHandler={routerHandler}
          />
        </VStack>
        <Text action="muted" size="sm" className="mt-4">
          Para crear una cuenta, haz click{" "}
          <Link href={{ pathname: "/register" }} asChild>
            <Button
              action="brand"
              variant="link"
              className="inline h-fit"
              size="sm"
            >
              <ButtonText>aquí.</ButtonText>
            </Button>
          </Link>
        </Text>
      </Card>
    </ScrollView>
  );
};

export default Index;
